export const classes = {
  link: 'text-base transition-colors mx-4 border-b-2 pb-1',
  active: 'text-blue-3 font-semibold border-blue-3',
  inactive: 'text-grey-8 font-normal border-white',
};
